export const WORKSPACE_URL_KEY = 'workspaceURL';

export const LANGUAGE_KEY = 'language';
